import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import { PENDO_MAX_WAIT_FOR_CALL, PENDO_MAX_WAIT_FOR_INIT, PENDO_CHECK_INTERVAL_MSEC, USER_DOMAIN_GENERIC, USER_DOMAIN_PURECARS, USER_TYPE_EXTERNAL, USER_TYPE_INTERNAL, EMAIL_DOMAINS_GENERIC, EMAIL_DOMAIN_INTERNAL } from './constants';
var pendoInitialized = false;
export var PendoNotExistError = /*#__PURE__*/function (_Error) {
  _inherits(PendoNotExistError, _Error);

  var _super = _createSuper(PendoNotExistError);

  function PendoNotExistError() {
    _classCallCheck(this, PendoNotExistError);

    return _super.call(this, "Pendo was not found on the page.");
  }

  return PendoNotExistError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Returns the Pendo object, which should only exist if Pendo was initialized
 * @return {Object} the Pendo object
 */

export function getPendoObject() {
  return window.pendo;
}
/**
 * Returns a promise that will be fulfilled when Pendo is initialized, or rejected after a max wait
 * @param {Number} maxWait - the maximum time to wait for Pendo to be initialized before rejecting
 * @return {Promise} - the Pendo initialization promise
 */

export function waitForPendo() {
  return _waitForPendo.apply(this, arguments);
}
/**
 * Initializes Pendo, if not already initialized by GTM.  It waits a little bit for GTM to init before trying
 * @param {Object} userData - User data
 * @param {Number} maxWait - the maximum time to wait for GTM to initialize Pendo before doing it here
 */

function _waitForPendo() {
  _waitForPendo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var maxWait,
        pendo,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            maxWait = _args.length > 0 && _args[0] !== undefined ? _args[0] : PENDO_MAX_WAIT_FOR_CALL;
            pendo = getPendoObject();

            if (!pendo) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", Promise.resolve(pendo));

          case 4:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var intervalsRemain = maxWait / PENDO_CHECK_INTERVAL_MSEC;
              var intervalCheck = setInterval(function () {
                var _pendo = getPendoObject();

                if (_pendo) {
                  clearInterval(intervalCheck);
                  resolve(_pendo);
                } else if (! --intervalsRemain) {
                  clearInterval(intervalCheck);
                  reject(new PendoNotExistError());
                }
              }, PENDO_CHECK_INTERVAL_MSEC);
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _waitForPendo.apply(this, arguments);
}

export function setPendoIdentity(_x) {
  return _setPendoIdentity.apply(this, arguments);
}

function _setPendoIdentity() {
  _setPendoIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userData) {
    var maxWait,
        email,
        id,
        firstName,
        lastName,
        userDomain,
        fullName,
        pendo,
        pendoFunc,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            maxWait = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : PENDO_MAX_WAIT_FOR_INIT;
            _context2.prev = 1;
            email = userData.email, id = userData.id, firstName = userData.firstName, lastName = userData.lastName;
            userDomain = getUserDomain(email);
            fullName = "".concat(firstName, " ").concat(lastName);
            _context2.next = 7;
            return waitForPendo(maxWait);

          case 7:
            pendo = _context2.sent;
            pendoFunc = pendoInitialized ? 'identify' : 'initialize'; // see https://developers.pendo.io/docs/?bash#installation

            pendo[pendoFunc]({
              visitor: _objectSpread({
                id: id,
                email: email,
                fullName: fullName
              }, userDomain)
            });
            pendoInitialized = true;
            window.pendoEventData = {}; // enable this to see pendo's debug widget in the page
            //pendo.enableDebugging()

            console.log('[Pendo]', pendoFunc, id, fullName);
            _context2.next = 18;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](1);
            console.error('[Pendo] not found');

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 15]]);
  }));
  return _setPendoIdentity.apply(this, arguments);
}

export function getUserDomain(email) {
  // If email is from PC, return with that
  if (email.includes(EMAIL_DOMAIN_INTERNAL)) {
    return {
      userType: USER_TYPE_INTERNAL,
      userDomain: USER_DOMAIN_PURECARS
    };
  } // If not, check if email is generic or not


  var isGenericDomain = EMAIL_DOMAINS_GENERIC.find(function (domain) {
    return email.includes(domain);
  }); // Return external type with appropriate domain

  return {
    userType: USER_TYPE_EXTERNAL,
    userDomain: isGenericDomain ? USER_DOMAIN_GENERIC : getDealerDomainFromEmail(email)
  };
}
/**
 * Strip domain from email address
 * @param email Email to strip
 * @returns domain (E.g. jim@jimellis.com => jimellis)
 */

export function getDealerDomainFromEmail(email) {
  return email.replace(/\S*@/g, '');
}
export default setPendoIdentity;